const inputClassName =
	'mt-1 block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500'

export default function RozmowaNewOsobaSection({ active = true, disabled, newOsoba, onChange, placowkaName, t }) {
	return (
		<div className={`rounded-lg border p-4 ${active ? 'border-indigo-200 bg-indigo-50/40' : 'border-gray-200 bg-gray-50'}`}>
			<h2 className="text-sm font-semibold text-gray-900">{t('conversations.add.newPerson.title')}</h2>
			<p className="mt-1 text-sm text-gray-500">{t('conversations.add.newPerson.hint')}</p>

			<div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
				<label className="flex flex-col" htmlFor="rozmowa-nowa-osoba-imie">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.newPerson.fields.fullName')} *</span>
					<input
						id="rozmowa-nowa-osoba-imie"
						type="text"
						value={newOsoba.imie_i_nazwisko}
						onChange={event => onChange('imie_i_nazwisko', event.target.value)}
						disabled={disabled}
						required={active && !disabled}
						className={inputClassName}
					/>
				</label>

				<label className="flex flex-col" htmlFor="rozmowa-nowa-osoba-funkcja">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.newPerson.fields.role')} *</span>
					<input
						id="rozmowa-nowa-osoba-funkcja"
						type="text"
						value={newOsoba.funkcja}
						onChange={event => onChange('funkcja', event.target.value)}
						disabled={disabled}
						required={active && !disabled}
						className={inputClassName}
					/>
				</label>

				<label className="flex flex-col" htmlFor="rozmowa-nowa-osoba-telefon">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.newPerson.fields.phone')} *</span>
					<input
						id="rozmowa-nowa-osoba-telefon"
						type="text"
						value={newOsoba.telefon}
						onChange={event => onChange('telefon', event.target.value)}
						disabled={disabled}
						required={active && !disabled}
						className={inputClassName}
					/>
				</label>

				<label className="flex flex-col" htmlFor="rozmowa-nowa-osoba-email">
					<span className="text-sm font-medium text-gray-700">{t('conversations.add.newPerson.fields.email')}</span>
					<input
						id="rozmowa-nowa-osoba-email"
						type="email"
						value={newOsoba.email}
						onChange={event => onChange('email', event.target.value)}
						disabled={disabled}
						className={inputClassName}
					/>
				</label>
			</div>

			<div className="mt-4">
				<span className="block text-sm font-medium text-gray-700">{t('conversations.add.placowkaLabel')}</span>
				<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700">
					{placowkaName || t('conversations.add.placeholders.personBeforeFacility')}
				</div>
			</div>
		</div>
	)
}
